<template>
	<div>
		<b-tabs>
			<b-tab title="Paramètres">
				<div :id="'jsoneditor-' + id"></div>
			</b-tab>
			<b-tab title="Post traitement">
				<p>Projet</p>
				<b-form-select
					:style="'max-width: ' + 500 + 'px'"
					@change="update_project"
					v-model="project_id"
					:options="projects_options"></b-form-select>
				<div v-show="project_id">
					<b-button variant="link" v-b-toggle="'collapse-project-' + id">Paramètres</b-button>
					<b-collapse :id="'collapse-project-' + id">
						<div :id="'jsoneditor-project-' + id"></div>
					</b-collapse>
				</div>
				<c_treatment_params v-show="project_id" ref="treatment_params" @change="change_treatment_params" :dashboard="false"></c_treatment_params>
				<div v-show="results_arr.length > 0" :style="'max-width: ' + (size - 100) + 'px'">
					<p>Données de tests</p>
					<edit_tabulator :extern_file="false" ref="edit_tabulator"></edit_tabulator>
					<b-button @click="test">Test</b-button>
				</div>
				<div v-if="spinner" class="center_spinner">
					<fade-loader></fade-loader>
				</div>
				<div v-show="results_arr_project.length > 0" :style="'max-width: ' + (size - 100) + 'px'">
					<p>Résultats</p>
					<edit_tabulator :extern_file="false" ref="edit_tabulator_result"></edit_tabulator>
				</div>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	
	const clone = require("clone");
	const _ = require("underscore");
	
	import treatments from "../services/treatments.js";
	import { schema_projet } from "../schemas-JSON/projet.js"
	import edit_tabulator from "../components/edit_tabulator.vue";
	import c_treatment_params from "../components/params.vue"

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	export default {
		name: "document_extraction_zone",
		components: {
			edit_tabulator,
			FadeLoader,
			c_treatment_params
		},
		props: {
			start_name: {},
			projects: {
				default: () => [],
			},
			projects_options: {
				default: () => [],
			},
			results_arr: {
				default: () => []
			},
			size: {},
			scenario: {}
		},
		watch: {
			results_arr: async function()
			{
				this.$refs.edit_tabulator.set_data(this.results_arr, [this.parameters.options.custom_output_key || this.parameters.name]);
			},
			column: function () {
					this.$refs.edit_tabulator.set_columns([this.column]);
			}
		},
		data() {
			return {
				id: uniqueId(""),
				editor: null,
				project_editor: null,
				parameters: {
					name: "",
					template: "",
					type: {},
					limit: [],
					condition_text: {},
					options: {}
				},
				position_parent: null,
				position: null,
				ready: false,
				first_load: false,

				project_id: "",
				project: null,
				params: null,

				results_arr_project: [],
				step: true,
				spinner: false,

				column: "",
				treatment_params: []
			};
		},
		methods: {
			save() {
				var data = {
					parameters: this.parameters,
					name: this.parameters.name,
					position_parent: this.position_parent,
					position: this.position,
					project_id: this.project_id,
					project: this.project,
					params: this.params,
				};

				return data;
			},
			async load(data) {
				while (!this.ready) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}

				console.log("load")
				console.log(data)

				this.step = false;

				this.parameters = data.parameters;
				this.editor.setValue(this.parameters);
				this.position_parent = data.position_parent || null;
				this.position = data.position || null;

				this.project_id = data.project_id || "";
				this.project = data.project || null;
				this.params = data.params || null;

				if (this.project_id)
				{
					for (var i = 0; i < this.projects.length; i++) {
						if (this.projects[i].uid == this.project_id) {
							this.project = this.projects[i];
						}
					}
				}

				if (this.project_id)
				{

					var params = null;
					if (this.params && this.params.params)
						params = clone(this.params.params);
						
					await this.setParameters(this.params)

					this.treatment_params = this.project.details.treatment_params || [];

					await this.$refs.treatment_params.set(this.treatment_params);

					// console.log(this.project)
					await this.setParameters();

					if (params)
					{
						this.$refs.treatment_params.set_obj(params);
					}
				}

				this.step = true
			},
			async update_project() {
				if (!this.project_id)
				{
					if (this.column)
						this.scenario.deleteStepByDescription("Post t - " + this.column);
					this.project = null;
					this.params = null;
					return;
				}

				// console.log(this.project_id)
				for (var i = 0; i < this.projects.length; i++) {
					if (this.projects[i].uid == this.project_id) {
						this.project = this.projects[i];

						this.treatment_params = this.project.details.treatment_params || [];
						await this.$refs.treatment_params.set(this.treatment_params);

						// console.log(this.project)
						await this.setParameters();

						if (this.params)
						{
							this.$refs.treatment_params.set_obj(this.params.params);
						}

						break;
					}
				}
			},
			change_treatment_params()
			{
				var params = this.project_editor.getValue();
				params.params = this.$refs.treatment_params.get_obj();
				
				this.project_editor.setValue(params);
			},
			async setParameters(params = null)
			{
				var self = this;

				if (this.project_editor) {
					this.project_editor.destroy();
					this.project_editor = null;
				}

				var json = {};
				json.project = this.project.uid;
				var schema = schema_projet(json);
				
				const element = document.getElementById(
					"jsoneditor-project-" + this.id
				);
				
				this.project_editor = new JSONEditor(element, {
					schema: schema,
					keep_oneof_values: false,
					theme: "bootstrap4",
					iconlib: "fontawesome5",
					prompt_before_delete: false,
					object_background: "",
					display_required_only: true,
					disable_edit_json: false,
					disable_properties: false,
					template: "handlebars",
				});
				
				await new Promise((resolve, reject) => {
					self.project_editor.on("ready", function () {
						resolve();
					});
				});

				this.params = null;
				this.project_editor.on("change", function () {

					var column = null;
					if (self.column)
						column = self.column;

					self.params = self.project_editor.getValue();
					self.column = self.params.params.column

					self.$refs.treatment_params.set_obj(self.params.params);

					if (column && column != self.column)
						self.scenario.deleteStepByDescription("Post t - " + column);

					if (self.step)
					{
						if (self.project_id)
						{
							if (self.scenario.existStepByDescription("Post t - " + self.column))
							{
								console.log("exist")
								self.scenario.updateStepParametersByDescription("Post t - " + self.column, self.params, self.project_id);
							}
							else
							{
								self.scenario.addStep({
									data: {
										action: "projet",
										label: "Post t - " + self.column,
										parameters: self.params,
										sql_rules: "",
									},
									description: "Post t - " + self.column,
									action: "projet",
									c_conditions: false,
									c_tree: false,
									c_project: true,
									project_id: self.project_id,
									c_parameters: true,
									c_tabulator: false,
									c_test: true,
									tabulator2: [],
									keep_start_data: false,
									option_delete: false,
									option_make_list: false,
									treatment: false,
								}, null, ["Analyse pdf - "]);
							}
						}
						else
							self.scenario.deleteStepByDescription("Post t - " + self.column);
					}
				});

				if (params)
				{
					this.project_editor.setValue(params);
					this.$refs.treatment_params.set_obj(params.params);
				}
				else
				{
					this.project_editor.setValue({
						project: this.project_id, 
						params: {
							column: this.parameters.options.custom_output_key || this.parameters.name
						}
					});
				}
			},
			setPosition(position, position_parent) {
				this.position = position;
				this.position_parent = position_parent;
			},
			getParams() {
				return this.parameters;
			},
			setParams(parameters) {
				this.parameters = parameters;
				this.editor.setValue(this.parameters);
			},
			addLimit(limit) {
				var c = 0;
				if (limit.type == "block") {
					if (!this.parameters.limit)
						this.parameters.limit = [];
					for (var i = 0; i < this.parameters.limit.length; i++) {
						if (this.parameters.limit[i].type == "block") {
							this.parameters.limit[i] = limit;
							c = 1;
							break;
						}
					}
				}
				if (c == 0) {
					this.parameters.limit.push(limit);
				}
				this.editor.setValue(this.parameters);
			},
			async test()
			{
				this.spinner = true;
				var formData = new FormData();

				var files = await this.$refs.edit_tabulator.get_data_files();
				formData.append(files[0].name, files[0]);

				var resp = await this.test_project(
					this.project,
					formData,
					this.params.tags,
					[],
					"",
					true,
					[],
					0,
					{},
					this.params,
					[],
					uniqueId()
				);

				console.log(resp)

				this.results_arr_project = resp.results || [];
				var columns = _.difference(Object.keys(this.results_arr_project[0]), Object.keys(this.results_arr[0]))
				columns.unshift(this.column);
				this.$refs.edit_tabulator_result.set_data(resp.results, columns);
				this.spinner = false;
			},
			async test_project(
				project,
				formData,
				tags,
				results_files,
				name_file,
				first_csv,
				urls,
				nb_step, 
				step,
				params,
				treatment_params,
				step_uid
			) {
				var results = []
				var tag_data = {};
				if (project.tags && tags) {
					for (var i = 0; i < project.tags.length; i++) {
						if (project.tags[i].tag == tags)
							tag_data = project.tags[i];
					}
				}
				var treatment_data = await treatments.create(
					project.uid,
					null,
					null,
					null,
					[tags],
					tag_data.type_import || "import",
					formData,
					params,
					treatment_params,
					step_uid
				);
				while (
					treatment_data.treatment.resultat != "ok" &&
					treatment_data.treatment.resultat != "ko"
				) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
					treatment_data = await treatments.get(
						treatment_data.treatment.uid
					);
				}
				var all_files = await treatments.getFiles(
					treatment_data.treatment.uid
				);
				if (!all_files || all_files.length == 0) all_files = [];
				all_files.sort((a, b) =>
					a.nom_fichier > b.nom_fichier ? 1 : -1
				);
				var export_type = tag_data.type_export || "export";
				for (var i = 0; i < all_files.length; i++) {
					if (nb_step <= 1) {
						if (
							first_csv &&
							all_files[i].type == export_type &&
							all_files[i].nom_fichier.endsWith(".csv") &&
							!step.file_result
						) {
							var csv_data = await treatments.getFile(
								all_files[i].uid,
								all_files[i].nom_fichier,
								false,
								false
							);
							name_file = all_files[i].nom_fichier;
							results = this.$papa.parse(csv_data, {
								header: true,
							});
							results = results.data;
							first_csv = false;
						} else if (all_files[i].type == export_type) {
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
						}
					} else {
						if (all_files[i].type == export_type)
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
					}
				}

				return { name_file, first_csv, urls, results };
			},
		},
		destroyed: async function() {
			if (this.column)
				this.scenario.deleteStepByDescription("Post t - " + this.column);
		},
		mounted: async function () {
			var self = this;
			var schema = {
				title: "Zone",
				type: "object",
				required: ["name", "type", "limit"],
				format: "categories",
				basicCategoryTitle: "Zone",
				properties: {
					name: {
						title: "Nom",
						type: "string",
					},
					template: {
						title: "Template",
						type: "string",
					},
					type: {
						title: "Type",
						type: "object",
						oneOf: [
							{
								title: "texte",
								required: ["type"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["texte"],
									},
								},
							},
							{
								title: "html",
								required: ["type"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["html"],
									},
								},
							},
							{
								title: "html complet",
								required: ["type"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["html complet"],
									},
								},
							},
							{
								title: "tableau",
								required: ["type", "method", "margin"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["tableau"],
									},
									method: {
										title: "Méthode",
										type: "string",
										enum: ["méthode 1", "méthode 2"],
									},
									margin: {
										title: "Marge",
										type: "number",
										default: 5,
										options: {
											hidden: true,
										},
									},
								},
							},
							{
								title: "tableau - méthode 2",
								required: ["type"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["tableau - méthode 2"],
									},
									config_cell: {
										title: "Type des cellules",
										type: "string",
										enum: [
											"texte",
											"html",
											"zones de texte",
										],
									},
									all_line: {
										title: "Toutes les cellules",
										type: "boolean",
										format: "checkbox",
									},
									align_top: {
										title: "Elargissement vertical",
										type: "string",
										enum: ["bas", "haut et bas"],
									},
									align_left: {
										title: "Elargissement horizontal",
										type: "string",
										enum: ["droite", "gauche et droite"],
									},
								},
							},
							{
								title: "zones de texte",
								required: ["type"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["zones de texte"],
									},
								},
							},
							{
								title: "Séquence",
								required: ["type"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["sequence"],
									},
									sequences: {
										title: "Séquences",
										type: "array",
										default: [[{}]],
										items: {
											title: "Séquence",
											type: "object",
											format: "categories",
											properties: {
												sequence: {
													title: "Séquence",
													format: "table",
													type: "array",
													default: [{}],
													items: {
														title: "Eléments",
														type: "object",
														properties: {
															type: {
																title: "Type",
																type: "string",
																enum: [
																	"texte",
																	"liste",
																	"séquence",
																	"regex",
																	"nombre",
																	"mots",
																	"nombre décimal",
																	"date (jour/mois/année)",
																	"téléphone",
																	"code postal",
																],
															},
															regex: {
																title: "Regex ou valeur",
																type: "string",
															},
															nb: {
																title: "Nombre d'occurences",
																type: "string",
																enum: [
																	"un",
																	"plusieurs",
																],
															},
															column: {
																title: "mapping",
																type: "string",
															},
															required: {
																title: "Obligatoire",
																type: "boolean",
																format: "checkbox",
															},
															temporary: {
																title: "Temporaire",
																type: "boolean",
																format: "checkbox",
															},
														},
													},
												},
												sequence_options: {
													title: "Séquence - options",
													format: "table",
													type: "array",
													default: [{}],
													items: {
														title: "Eléments",
														type: "object",
														properties: {
															column: {
																title: "mapping",
																type: "string",
															},
															max: {
																title: "Max",
																type: "boolean",
																format: "checkbox",
															},
															bold: {
																title: "Gras",
																type: "string",
																enum: [
																	"oui",
																	"non",
																],
																default: "",
															},
															italic: {
																title: "Italique",
																type: "string",
																enum: [
																	"oui",
																	"non",
																],
																default: "",
															},
															font_color: {
																title: "Couleur",
																type: "string",
																enum: [
																	"même couleur",
																],
																default: "",
															},
															font_size: {
																title: "Taille",
																type: "string",
																default: "",
															},
														},
													},
												},
												options: {
													title: "Options",
													type: "object",
													properties: {
														name: {
															title: "Nom",
															type: "string",
														},
														column: {
															title: "Colonne",
															type: "string",
														},
														object: {
															title: "Objet",
															type: "boolean",
															format: "checkbox",
														},
														parent: {
															title: "Parent",
															type: "boolean",
															format: "checkbox",
														},
														strict: {
															title: "Strict",
															type: "boolean",
															format: "checkbox",
														},
														group_regex: {
															title: "Groupe de regex",
															type: "boolean",
															format: "checkbox",
														},
														separator: {
															title: "Séparateur",
															type: "string",
															default: " ",
														},
														meta_split: {
															title: "Séparer en fonction des styles",
															type: "boolean",
															format: "checkbox",
															default: false,
														},
													},
												},
											},
										},
									},
									end: {
										title: "Fin",
										type: "string",
										enum: ["", "fin de ligne"],
									},
									separator_line: {
										title: "Séparateur de fin de ligne",
										type: "string",
									},
									separator_block: {
										title: "Séparateur de zones de texte",
										type: "string",
									},
								},
							},
							{
								title: "template",
								required: ["type", "template"],
								properties: {
									type: {
										title: "Type",
										type: "string",
										enum: ["template"],
									},
									template: {
										title: "Template",
										type: "string",
									},
								},
							},
						],
					},
					limit: {
						type: "array",
						title: "Limites",
						items: {
							type: "object",
							title: "Limite",
							oneOf: [
								{
									title: "Coordonnées",
									required: [
										"type",
										"x",
										"y",
										"limit_x",
										"limit_y",
									],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["coordinates"],
											options: { hidden: true },
										},
										x: {
											type: "integer",
											title: "X",
										},
										y: {
											type: "integer",
											title: "Y",
										},
										limit_x: {
											type: "string",
											title: "La zone se situe par rapport aux coordonnées",
											enum: ["", "A gauche", "A droite"],
										},
										limit_y: {
											type: "string",
											title: "La zone se situe par rapport aux coordonnées",
											enum: [
												"",
												"Au dessus",
												"En dessous",
											],
										},
										relative: {
											type: "boolean",
											format: "checkbox",
											title: "Positions relatives",
										},
									},
								},
								{
									title: "Rectangle",
									required: ["type", "x1", "y1", "x2", "y2"],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["block"],
											options: { hidden: true },
										},
										x1: {
											type: "integer",
											title: "X1",
										},
										y1: {
											type: "integer",
											title: "Y1",
										},
										x2: {
											type: "integer",
											title: "X2",
										},
										y2: {
											type: "integer",
											title: "Y2",
										},
										relative: {
											type: "boolean",
											format: "checkbox",
											title: "Positions relatives",
										},
									},
								},
								{
									title: "Zone de texte",
									required: [
										"type",
										"search",
										"limit_x",
										"limit_y",
										"position",
									],
									properties: {
										search: {
											title: "Recherches",
											type: "array",
											items: {
												title: "Recherche",
												type: "object",
												oneOf: [
													{
														title: "Texte",
														required: [
															"type",
															"type_search",
															"value",
														],
														properties: {
															type: {
																type: "string",
																title: "type",
																enum: ["texte"],
																options: {
																	hidden: true,
																},
															},
															type_search: {
																type: "string",
																title: "Type de recherche",
																enum: [
																	"Contient",
																	"Commence par",
																	"Termine par",
																	"Est égal",
																	"Regex",
																],
															},
															value: {
																type: "string",
																format: "textarea",
																title: "Valeur",
															},
														},
													},
													{
														title: "Html",
														required: [
															"type",
															"type_search",
															"value",
														],
														properties: {
															type: {
																type: "string",
																title: "type",
																enum: ["html"],
																options: {
																	hidden: true,
																},
															},
															type_search: {
																type: "string",
																title: "Type de recherche",
																enum: [
																	"Contient",
																	"Commence par",
																	"Termine par",
																	"Est égal",
																	"Regex",
																],
															},
															value: {
																type: "string",
																title: "Valeur",
															},
														},
													},
													{
														title: "Couleur de fond",
														required: [
															"type",
															"value",
														],
														properties: {
															type: {
																type: "string",
																title: "type",
																enum: [
																	"background_color",
																],
																options: {
																	hidden: true,
																},
															},
															value: {
																type: "string",
																title: "Valeur",
															},
														},
													},
													{
														title: "Couleur",
														required: [
															"type",
															"value",
														],
														properties: {
															type: {
																type: "string",
																title: "type",
																enum: ["color"],
																options: {
																	hidden: true,
																},
															},
															value: {
																type: "string",
																title: "Valeur",
															},
															gap: {
																type: "string",
																title: "Ecart",
															},
														},
													},
													{
														title: "Taille",
														required: [
															"type",
															"type_search",
															"value",
														],
														properties: {
															type: {
																type: "string",
																title: "type",
																enum: [
																	"size_text",
																],
																options: {
																	hidden: true,
																},
															},
															type_search: {
																type: "string",
																title: "Type de recherche",
																enum: [
																	"Egal",
																	"Supérieur",
																	"Supérieur ou égal",
																	"Inférieur",
																	"Inférieur ou égal",
																	"Intervalle",
																],
															},
															value: {
																type: [
																	"number",
																	"string",
																],
																title: "Valeur",
																default: 0,
															},
														},
													},
													{
														title: "Position",
														required: [
															"type",
															"position",
															"type_search",
															"value",
														],
														properties: {
															type: {
																type: "string",
																title: "type",
																enum: [
																	"position",
																],
																options: {
																	hidden: true,
																},
															},
															position: {
																type: "string",
																enum: [
																	"position.top",
																	"position.left",
																	"position.bottom",
																	"position.right",
																	"position.height",
																	"position.width",
																	"position_absolute.top",
																	"position_absolute.left",
																	"position_absolute.bottom",
																	"position_absolute.right",
																],
																title: "Position",
															},
															type_search: {
																type: "string",
																title: "Type de recherche",
																enum: [
																	"Egal",
																	"Supérieur",
																	"Supérieur ou égal",
																	"Inférieur",
																	"Inférieur ou égal",
																	"Intervalle",
																],
															},
															value: {
																type: "number",
																title: "Valeur",
																default: 0,
															},
														},
													},
												],
											},
										},
										type: {
											type: "string",
											title: "type",
											enum: ["zone_text_limit"],
											options: { hidden: true },
										},
										required: {
											type: "boolean",
											title: "Zone obligatoire",
											format: "checkbox",
										},
										position: {
											title: "Position",
											type: "string",
											enum: [
												"Premier",
												"Deuxième",
												"Dernier",
											],
										},
										limit_x: {
											title: "La zone se situe par rapport à la zone de texte",
											type: "string",
											enum: [
												"",
												"Au dessus avec la zone",
												"Au dessus",
												"En dessous avec la zone",
												"En dessous",
												"Entre la zone en horizontal",
											],
										},
										limit_y: {
											title: "La zone se situe par rapport à la zone de texte",
											type: "string",
											enum: [
												"",
												"A gauche avec la zone",
												"A gauche",
												"A droite avec la zone",
												"A droite",
												"Entre la zone en vertical",
											],
										},
									},
								},
								{
									title: "Zone",
									required: [
										"type",
										"name",
										"limit_x",
										"limit_y",
									],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["zone_limit"],
											options: { hidden: true },
										},
										name: {
											title: "Nom de la zone recherché",
											type: "string",
										},
										position: {
											title: "Position",
											type: "string",
											enum: ["Premier", "Dernier"],
										},
										limit_x: {
											title: "La zone se situe par rapport à la zone recherchée",
											type: "string",
											enum: [
												"",
												"Au dessus avec la zone",
												"Au dessus",
												"En dessous avec la zone",
												"En dessous",
												"Entre la zone en horizontal",
											],
										},
										limit_y: {
											title: "La zone se situe par rapport à la zone recherchée",
											type: "string",
											enum: [
												"",
												"A gauche avec la zone",
												"A gauche",
												"A droite avec la zone",
												"A droite",
												"Entre la zone en vertical",
											],
										},
									},
								},
							],
						},
					},
					condition_text: {
						title: "Conditions des zones de texte",
						type: "array",
						items: {
							title: "Condition",
							type: "object",
							oneOf: [
								{
									title: "Texte",
									required: ["type", "type_search", "value"],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["texte"],
											options: { hidden: true },
										},
										type_search: {
											type: "string",
											title: "Type de recherche",
											enum: [
												"Contient",
												"Commence par",
												"Termine par",
												"Est égal",
												"Regex",
											],
										},
										value: {
											type: "string",
											format: "textarea",
											title: "Valeur",
										},
									},
								},
								{
									title: "Html",
									required: ["type", "type_search", "value"],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["html"],
											options: { hidden: true },
										},
										type_search: {
											type: "string",
											title: "Type de recherche",
											enum: [
												"Contient",
												"Commence par",
												"Termine par",
												"Est égal",
												"Regex",
											],
										},
										value: {
											type: "string",
											title: "Valeur",
										},
									},
								},
								{
									title: "Couleur de fond",
									required: ["type", "value"],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["background_color"],
											options: { hidden: true },
										},
										value: {
											type: "string",
											title: "Valeur",
										},
									},
								},
								{
									title: "Couleur",
									required: ["type", "value"],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["color"],
											options: { hidden: true },
										},
										value: {
											type: "string",
											title: "Valeur",
										},
										gap: {
											type: "string",
											title: "Ecart",
										},
									},
								},
								{
									title: "Taille",
									required: ["type", "type_search", "value"],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["size_text"],
											options: { hidden: true },
										},
										type_search: {
											type: "string",
											title: "Type de recherche",
											enum: [
												"Egal",
												"Supérieur",
												"Supérieur ou égal",
												"Inférieur",
												"Inférieur ou égal",
												"Intervalle",
											],
										},
										value: {
											type: ["number", "string"],
											title: "Valeur",
											default: 0,
										},
									},
								},
								{
									title: "Position",
									required: [
										"type",
										"position",
										"type_search",
										"value",
									],
									properties: {
										type: {
											type: "string",
											title: "type",
											enum: ["position"],
											options: { hidden: true },
										},
										position: {
											type: "string",
											enum: [
												"position.top",
												"position.left",
												"position.bottom",
												"position.right",
												"position.height",
												"position.width",
												"position_absolute.top",
												"position_absolute.left",
												"position_absolute.bottom",
												"position_absolute.right",
											],
											title: "Position",
										},
										type_search: {
											type: "string",
											title: "Type de recherche",
											enum: [
												"Egal",
												"Supérieur",
												"Supérieur ou égal",
												"Inférieur",
												"Inférieur ou égal",
												"Intervalle",
											],
										},
										value: {
											type: "number",
											title: "Valeur",
											default: 0,
										},
									},
								},
							],
						},
					},
					options: {
						type: "object",
						title: "Options avancées",
						properties: {
							height: {
								title: "Hauteur",
								type: "number",
							},
							width: {
								title: "Largeur",
								type: "number",
							},
							repeat: {
								title: "Répéter la zone",
								type: "boolean",
								format: "checkbox",
							},
							new_line: {
								title: "Nouvelle ligne",
								type: "checkbox",
								format: "boolean",
							},
							custom_output_key: {
								title: "Nom de colonne personnalisée",
								type: "string",
							},
							object: {
								title: "Objet",
								type: "boolean",
								format: "checkbox",
							},
							multiline: {
								title: "Multi pages (début)",
								type: "boolean",
								format: "checkbox",
							},
							multiline_end: {
								title: "Multi pages (fin)",
								type: "boolean",
								format: "checkbox",
							},
							split_line: {
								title: "Découper les lignes",
								type: "boolean",
								format: "checkbox",
							},
							condition_page: {
								title: "Page",
								type: "string",
							},
							condition_rotation: {
								title: "Rotation",
								type: "string",
							},
							assemble: {
								title: "Ratacher les zones de textes proches",
								type: "integer",
							},
						},
					},
				},
			};

			const element = document.getElementById("jsoneditor-" + this.id);

			this.editor = new JSONEditor(element, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				keep_oneof_values: false,
				prompt_before_delete: false,
				object_background: "",
				display_required_only: false,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					self.ready = true;
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				self.parameters = self.editor.getValue();
				self.$emit("update", self.parameters);

				if (self.project_id)
				{
					self.project_editor.setValue({
						project: self.project_id, 
						params: {
							column: self.parameters.options.custom_output_key || self.parameters.name
						}
					});
				}
			});

			if (this.start_name) {
				self.parameters = self.editor.getValue();
				self.parameters.name = self.start_name;
				self.editor.setValue(self.parameters);
			}
		},
	};
</script>

<style></style>
